import { CropFieldAdvice } from '@app/shared/components/disease-overview-table.component/models/models';
import { HasPlantDateTracking } from '../../shared/models/plant-date-tracking';

export enum SprayAdvice {
  cropsProtected = 'CROPS_PROTECTED',
  preventive = 'PREVENTIVE',
  curative = 'CURATIVE',
  stop = 'STOP',
  noAdvice = 'NO_ADVICE',
}

export interface BlightCropFieldAdvice {
  cropFieldId: number;
  cropFieldName: string;
  cropVarietyName?: string;
  cropYear: number;
  amountOfHectares: number;
  advices: DailyAdvice[];
  todaysAdvice?: DailyAdvice;
  lastSprayDate?: Date;
  plantDate?: Date;
  emergenceDate?: Date;
  harvestDate?: Date;
  isCropFieldVisible: boolean;
}

export interface DailyAdvice {
  date: Date;
  sprayAdvice: SprayAdvice;
  remainingFungicidePercentage: number;
  isSprayedToday: boolean;
  translationKey?: string;
  stylingOverride?: { [key: string]: string } | null;
}

export interface AdviceMouseClickEvent {
  mouseEvent: MouseEvent;
  cropField: CropFieldAdvice;
}

/** @deprecated Legacy blight notification contract. Use blight-v2 status notifications instead. */
export enum BlightEvents {
  blightSyncStatusUpdated = 'Arable_BlightSyncStatusUpdated',
}

export interface ParticipatingCropField {
  id: number;
  name: string;
  areaInHectares: number;
  cropId: number;
  cropVarietyName?: string;
}

export interface BlightData {
  year: number;
  cropFieldId: number;
  cropVarietyName?: string;
  syncStatus: string;
  blightResult?: BlightResult;
  plantDate?: Date;
  plantDateCreatedAt?: Date;
  plantDateUpdatedAt?: Date;
  harvestDate?: Date;
  emergenceDate?: Date;
  lastSprayDate?: Date;
  isCropFieldVisible: boolean;
}

export interface BlightResult {
  calculatedOn?: Date;
  today?: Day;
  days: Day[] | null;
}

export interface Day {
  date: Date;
  infectionRisk: number;
  precipitation: number;
  fungicideLeftPct: number;
  sprayType: number;
  sprayEffectivity: string;
  sprayTime?: Date;
  infectionRiskPerHour?: number[];
  weather?: BlightChartDetailsWeather[];
}

export interface CustomerBlightRights {
  isPremium: boolean;
  customerId: number;
}

export interface BlightDayRange {
  daysInPast: number;
  daysInFuture: number;
}

/** @deprecated Legacy blight notification contract. Use blight-v2 status notifications instead. */
export interface BlightSyncStatusUpdatedEvent {
  isSuccessful: boolean;
  customerId: number;
  cropFieldId: number;
  timestamp: Date;
}

export interface BlightChartDetail {
  syncStatus: string;
  blightResult: BlightChartDetailsResult;
}

export interface BlightChartDetailsResult {
  calculatedOn: Date | null;
  days: BlightChartDetailsDay[];
}

export interface BlightChartDetailsDay {
  infectionRiskPerHour: number[];
  sprayTime: Date | null;
  sprayType: number;
  sprayEffectivity: number;
  date: Date;
  fungicideLeftPct: number;
  unprotectedGrowth: number;
  tuberInfectionRisk: number;
  ooSporesRisk: boolean;

  weather: BlightChartDetailsWeather[];
}

export interface BlightChartDetailsWeather {
  precipitation?: number;
  irrigation?: number;
  temperature?: number;
  humidity?: number;
  hour: number;
}

export type CropFieldRegistration = HasPlantDateTracking & {
  id: number;
  cropFieldId: number;
  year: number;
  plantDate: Date;
  emergenceDate: Date;
  harvestDate: Date;
  isPlantDateConfirmed: boolean;
  externalCropFieldId: string;
  feature: string;
  created: Date;
  updated: Date;
  diseasePressure: PhytophthoraPressure;
  suppressSprayAdvice: boolean;
};

export enum PhytophthoraPressure {
  low = 'Low',
  normal = 'Normal',
  high = 'High',
}

export const PotatoAgrifirmCropIds = [1001, 1004, 1005, 1007, 1008];
